import { render, staticRenderFns } from "./confirmDeleteModal.vue?vue&type=template&id=b8607610"
import script from "./confirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./confirmDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports